import { CategoryType } from "../types/types";


enum CopyRightLabel  {
  CircularProducts = 'Garbe-Gruppe',
  ConcreteRecycledAggregates = 'Susanne Wegner',
  ConcreteModulesConcrete = '',
  ProductsUsingLessMaterial = 'PERI GmbH',
  Special3DConcretePrinting = 'Aleksey Keksel',
  UHPCs = 'Steffen Fuchs',
  DecarbonisedProducts = 'Susanne Wegner',
  BrevikCCS = '',
  LengfurtCCU = 'Steffen Fuchs',
  CarbonReducedProducts = 'Susanne Wegner',
  SubstitutingClinkerWithFlyAsh = 'SEFA Group',
  SubstitutingClinkerWithCalcineClay = 'CBI Ghana'
}

const getCopyRightLabelByCategory = (cat: CategoryType) => {
  if (cat === "CircularProducts") return CopyRightLabel.CircularProducts;
  if (cat === "ConcreteRecycledAggregates") return CopyRightLabel.ConcreteRecycledAggregates;
  if (cat === "ConcreteModulesConcrete") return CopyRightLabel.ConcreteModulesConcrete;
  if (cat === "ProductsUsingLessMaterial") return CopyRightLabel.ProductsUsingLessMaterial;
  if (cat === "Special3DConcretePrinting") return CopyRightLabel.Special3DConcretePrinting;
  if (cat === "UHPCs") return CopyRightLabel.UHPCs;
  if (cat === "DecarbonisedProducts") return CopyRightLabel.DecarbonisedProducts;
  if (cat === "BrevikCCS") return CopyRightLabel.BrevikCCS;
  if (cat === "LengfurtCCU") return CopyRightLabel.LengfurtCCU;
  if (cat === "CarbonReducedProducts") return CopyRightLabel.CarbonReducedProducts;
  if (cat === "SubstitutingClinkerWithFlyAsh")  return CopyRightLabel.SubstitutingClinkerWithFlyAsh;
  if (cat === "SubstitutingClinkerWithCalcineClay") return CopyRightLabel.SubstitutingClinkerWithCalcineClay;
};

export default getCopyRightLabelByCategory;